/** Einheitlicher Platzhalter für Screens, die Phase 1 füllt. */
export function Placeholder({
  title,
  icon,
  children,
}: {
  title: string;
  icon?: string;
  children?: preact.ComponentChildren;
}) {
  return (
    <section class="stack">
      <h1>
        {icon ? <span aria-hidden="true">{icon} </span> : null}
        {title}
      </h1>
      <div class="glass" style="padding: var(--sp-5)">
        {children ?? (
          <p class="text-muted" style="margin:0">
            Dieser Bereich wird in <strong>Phase 1</strong> mit Inhalt gefüllt.
            Das Gerüst (Navigation, Theme, Datenschicht, Registries) steht.
          </p>
        )}
      </div>
    </section>
  );
}
